import ReverseQuestionIcon from './component'

export default ReverseQuestionIcon
